import { STATUS_CODE } from '@kc-console/core';

import { CookieKeyMap, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../../../constants';
import { parseCookies } from '../../../utils/cookie/parseCookies';

import type { BaseState } from '@kc-console/context';
import type { Guard } from '../../../types';

const ACCOUNT_LANGUAGE_COOKIE_KEY = 'KC_ACCOUNT_LANG';

export const determineAccountLanguageGuard: Guard<BaseState> = async ({ context }) => {
  const { req } = context;
  const cookies = parseCookies(req.headers.cookie || '');

  // 1. KC_ACCOUNT_LANG 쿠키 확인 (Account 클라이언트에서 설정)
  const accountLangCookie = cookies[ACCOUNT_LANGUAGE_COOKIE_KEY];
  if (accountLangCookie && SUPPORTED_LANGUAGES.includes(accountLangCookie)) {
    return {
      language: accountLangCookie,
      status: STATUS_CODE.OK,
    };
  }

  // 2. KC_DISPLAY_LANG 쿠키 확인
  const displayLangCookie = cookies[CookieKeyMap.DISPLAY_LANGUAGE_KEY];
  if (displayLangCookie && SUPPORTED_LANGUAGES.includes(displayLangCookie)) {
    return {
      language: displayLangCookie,
      status: STATUS_CODE.OK,
    };
  }

  // 3. KC_LANG 쿠키 확인
  const kcLangCookie = cookies[CookieKeyMap.LANGUAGE_KEY];
  if (kcLangCookie && SUPPORTED_LANGUAGES.includes(kcLangCookie)) {
    return { language: kcLangCookie, status: STATUS_CODE.OK };
  }

  // 4. Accept-Language 헤더 확인
  const acceptLanguage = req.headers['accept-language']?.split(',')[0]?.split('-')[0];
  if (acceptLanguage && SUPPORTED_LANGUAGES.includes(acceptLanguage)) {
    return { language: acceptLanguage, status: STATUS_CODE.OK };
  }

  // 5. 기본값 반환
  return { language: DEFAULT_LANGUAGE, status: STATUS_CODE.OK };
};

determineAccountLanguageGuard.displayName = 'determineAccountLanguageGuard';
